import React from "react"
import {
  ListItem,
  ListItemIcon,
  Checkbox,
  ListItemText,
  Typography,
  Box,
} from "@material-ui/core"

interface SingleSelectTagProps {
  title: string
  option: string
  isChecked: boolean
  onChecked: () => void
}

export const SingleSelectTag: React.FC<SingleSelectTagProps> = ({
  title,
  option,
  isChecked,
  onChecked,
}) => {
  return (
    <>
      <Box ml={1} mt={1}>
        <Typography id={`${title}-title`} variant="subtitle2" component="h2">
          {title}
        </Typography>
      </Box>
      <ListItem role={undefined} button dense onClick={onChecked}>
        <ListItemIcon>
          <Checkbox
            edge="start"
            checked={isChecked}
            tabIndex={-1}
            disableRipple
            inputProps={{ "aria-labelledby": `${title}-title` }}
          />
        </ListItemIcon>
        <ListItemText primary={option} />
      </ListItem>
    </>
  )
}
